import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faFaceSmile } from "@fortawesome/free-solid-svg-icons/faFaceSmile";
import React from "react";
import styled from "styled-components";

import { Spacing } from "../theme/Spacing";
import { AtiraIcon } from "./AtiraIcon";
import { Button } from "./Button";
import { Flex } from "./Flex";
import { Text } from "./Text";
import { Tooltip, Empty } from "../utils/local-antd";

const Container = styled(Flex)<{ iconHeight?: React.CSSProperties["height"] }>`
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${Spacing.m};

  .ant-empty-image {
    height: ${({ iconHeight }) => iconHeight};
  }
`;

const StyledButton = styled(Button)`
  padding-inline: ${Spacing.xxl};

  &:hover {
    background-color: ${({ theme }) => theme.lightMain};
  }
`;

interface AtiraErrorProps {
  icon?: IconProp;
  iconHeight?: React.CSSProperties["height"];
  description: string;
  action?: {
    title: string;
    onClick?: VoidFunction;
    disabled?: boolean;
    tooltip?: string;
    hide?: boolean;
    dataTestId?: string;
  };
}

export const AtiraEmpty: React.FC<AtiraErrorProps> = ({
  description,
  icon = faFaceSmile,
  iconHeight = "100px",
  action,
}) => {
  return (
    <Container iconHeight={iconHeight}>
      <Empty
        image={icon ? <AtiraIcon icon={icon} color="main" /> : undefined}
        description={
          <Text color="main" fontSize="l" align="center">
            {description}
          </Text>
        }
      />

      {action?.title && action?.onClick && !action?.hide ? (
        <Tooltip title={action?.tooltip}>
          <StyledButton
            onClick={action.onClick}
            disabled={action?.disabled || false}
            dataTestId={action.dataTestId}
          >
            {action.title}
          </StyledButton>
        </Tooltip>
      ) : null}
    </Container>
  );
};
